import { render, staticRenderFns } from "./footerContent.vue?vue&type=template&id=36934ece&scoped=true&"
import script from "./footerContent.vue?vue&type=script&lang=js&"
export * from "./footerContent.vue?vue&type=script&lang=js&"
import style0 from "./footerContent.vue?vue&type=style&index=0&id=36934ece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36934ece",
  null
  
)

export default component.exports